import { EmittersPolygonShapeGenerator } from "./EmittersPolygonShapeGenerator.js";
export async function loadEmittersShapePolygon(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("polygon", new EmittersPolygonShapeGenerator());
    await emittersEngine.refresh(refresh);
}
